/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import dayjs from '@/lib/dayjs';
import { type Locale } from '@/types/i18n';

export function formatStoreTime(time: string, locale: Locale): string {
  const date = dayjs(`2000-01-01 ${time}`);

  if (locale === 'en-US' || locale === 'es-MX') {
    return date.format('h:mm A');
  } else {
    return date.format('HH:mm');
  }
}
